export default __webpack_public_path__ + "static/media/Lagunes60s.dfb9bbe4.mp3";